import React from 'react';
import 'bootstrap/dist/js/bootstrap.esm.min';
import Config from './assets/config.json';
import { Header, Map, Municipalities } from './components/layout';
import Loader from './components/widgets/Loader';
import './assets/scss/main.scss';

class App extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			LoaderToggle: false,
			MapSetStyles: false
		}
		this.Loader = React.createRef();
		this.Map = React.createRef();
	}

	componentDidMount() {
		document.documentElement.lang = Config.LOCALE_HTML;
		this.setState({
			LoaderToggle: this.Loader.current.Toggle,
			MapSetStyles: this.Map.current.SetStyles
		});
	}

	render() {
		return <div className="app">
			<main className="h-100">
				<div className="container-fluid h-100 px-0">
					<div className="row h-100 mx-0">
						<div className="col-12 col-md-8 col-lg-9 px-0 d-flex flex-column h-100">
							<Header LoaderToggle={this.state.LoaderToggle} />
							<Map className="flex-grow-1" LoaderToggle={this.state.LoaderToggle} ref={this.Map}>
								<div className="logo">
									<img src={process.env.PUBLIC_URL + '/images/logo.png'} className="img-fluid" alt="" />
								</div>
							</Map>
						</div>
						<div className="col-md-4 col-lg-3 px-0">
							<Municipalities className="h-100" LoaderToggle={this.state.LoaderToggle} MapSetStyles={this.state.MapSetStyles} />
						</div>
					</div>
				</div>
			</main>
			<Loader ref={this.Loader} />
		</div>
	}
}

export default App;